module.exports = __webpack_public_path__ + "b4adb07767bac2722eaf53c10a492bb1.pdf";